import React, { Component } from 'react';
import styles from './loader.css';

import Summary from '../../components/Summary/Summary';

import DataActions  from '../../actions/DataActions.js';

class Loader extends Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      promises: Modernizr.promises
    };
  }

  componentDidMount() {
    if (this.state.promises) {
      DataActions.getPages((response)=> {
        this.setState({ loading: false });
      });
    }
  }

  render() {
  	if (this.state.loading === true) {
  		return (
        <div className={styles.content}></div>
      );
    } else if (!this.state.promises) {
      const data = `<p><strong>Not Supported</strong> — Sorry this website uses technology that is not supported by your browser. Please update your browser to the latest version two view.</p>`;
      return (
        <div className={styles.notSupported}>
          <Summary data={data} />
        </div>
      );
  	} else {
  		return (
	      <div>
	      	{this.props.children}
	      </div>
    	);
  	}
  }
}

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader/Loader.js